import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as Caution } from '@assets/icons/caution.svg';
import { Variants } from '@common/types';

import Label from '../Label/Label';

export const InputContainerStyled = styled(Box, {
  textAlign: 'left',
});

export const StyledLabelContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
});

export const StyledInputLabel = styled(Box, {
  variants: {
    variant: {
      [Variants.PRIMARY]: {},
      [Variants.SECONDARY]: {
        display: 'flex',
        height: '$8',
        border: '1px solid $colors$seafoam500',
        padding: '$1 $2',
        borderRadius: '$4',
      },
      [Variants.TERTIARY]: {
        display: 'flex',
        height: '$8',
        border: '1px solid $colors$seafoam500',
        padding: '$1 $2',
        borderRadius: '$4',
      },
    },
    error: {
      true: {},
    },
  },
  compoundVariants: [
    {
      error: true,
      variant: Variants.SECONDARY,
      css: {
        border: '$borderWidths$1 solid $error',
      },
    },
  ],
});

export const InputStyled = styled('input', {
  // Reset
  border: 'none',
  padding: '$0',
  backgroundColor: 'transparent',

  borderBottom: '$borderWidths$1 solid $darkGray700',
  fontSize: '$md',
  width: '100%',
  lineHeight: '$6',
  '&:focus': {
    outline: 'none',
  },
  '&:disabled': {
    borderBottom: '$borderWidths$1 solid $darkGray700',
    pointerEvents: 'none',
  },
  variants: {
    error: {
      true: {},
    },
    variant: {
      [Variants.PRIMARY]: {
        '&:hover': {
          borderBottom: '$borderWidths$1 solid $charcoal300',
        },
        '&:focus': {
          borderBottom: '$borderWidths$2 solid $darkBlue300',
        },
        '&::placeholder': {
          fontStyle: 'italic',
        },
      },
      [Variants.SECONDARY]: {
        flexGrow: '2',
        border: '$0',
        textAlign: 'right',
        '&:hover,&:focus': {
          border: '$0',
        },
        '&::placeholder': {
          color: '$seafoam400',
          fontWeight: '$medium',
          fontSize: '$xs',
          lineHeight: '$4',
          fontStyle: 'normal',
        },
      },
      [Variants.TERTIARY]: {
        border: '$0',
        color: '#667085',
        flexGrow: '2',
        fontSize: '$md',
        textAlign: 'left',
        '&:hover,&:focus': {
          border: '$0',
        },
      },
    },
  },
  compoundVariants: [
    {
      error: true,
      variant: Variants.SECONDARY,
      css: {
        borderBotton: '0',
      },
    },
    {
      error: true,
      variant: Variants.PRIMARY,
      css: {
        borderBottom: '$borderWidths$1 solid $error',
      },
    },
  ],
  '&::-webkit-contacts-auto-fill-button': {
    visibility: 'hidden',
  },
});

export const StyledLabel = styled(Label, {
  variants: {
    variant: {
      [Variants.PRIMARY]: {},
      [Variants.SECONDARY]: {
        fontWeight: '$bold',
        fontSize: '$normal',
        lineHeight: '$6',
        color: '$darkBlue400',
        marginRight: '$2',
      },
      [Variants.TERTIARY]: {},
    },
  },
});

export const CautionIconStyled = styled(Caution, {
  color: '$error',
  display: 'inline-block',
  height: '$6',
  width: '$6',
});

export const ErrorDescriptionStyled = styled('p', {
  color: '$error',
  display: 'inline-block',
  fontSize: '$xs',
  fontWeight: '$medium',
  mt: '$0',
  mb: '$0',
});

export const ErrorBoxStyled = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  mt: '$2',
});
